import { render, staticRenderFns } from "./TranscriptionSubtitle.vue?vue&type=template&id=ed9eebf4&"
import script from "./TranscriptionSubtitle.vue?vue&type=script&lang=ts&"
export * from "./TranscriptionSubtitle.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptionSubtitle.vue?vue&type=style&index=0&id=ed9eebf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports